import type { LonLat } from "../lib/geo";

export const stationPoints: LonLat[] = [
  [115.86, -31.95],
  [121.47, -30.75],
  [130.84, -12.46],
  [138.6, -34.92],
  [144.96, -37.81],
  [147.33, -42.88],
  [149.13, -35.28],
  [151.21, -33.86],
  [153.03, -27.47],
  [146.82, -19.25],
  [145.77, -16.92],
  [142.7, -20.73],
  [133.88, -23.7],
  [117.88, -35.02],
  [146.92, -36.08],
  [150.89, -34.43],
  [152.52, -31.43],
  [141.45, -31.95],
  [135.87, -34.72],
  [118.6, -20.3],
  [122.23, -17.96],
  [131.04, -25.34],
  [139.49, -20.73],
  [145.3, -37.19],
  [148.0, -23.38],
  [153.43, -28.02],
  [150.52, -23.38],
  [140.78, -37.83],
  [120.55, -27.72],
  [128.74, -15.77]
];

export const cycloneTrack: LonLat[] = [
  [151.8, -11.5],
  [150.4, -13.6],
  [148.9, -15.4],
  [147.4, -17.2],
  [146.7, -19.6],
  [146.2, -22.1]
];

export const ecosystemNodes = [
  { id: "bom", label: "BoM", layer: 0, role: "Official meteorology, observations, ACCESS and BARRA2." },
  { id: "ga", label: "Geoscience Australia", layer: 0, role: "Foundational geospatial and exposure context." },
  { id: "rms", label: "Moody's RMS", layer: 1, role: "Catastrophe modelling and analytics." },
  { id: "verisk", label: "Verisk", layer: 1, role: "Insurance risk analytics." },
  { id: "xdi", label: "XDI", layer: 1, role: "Asset-level climate risk intelligence." },
  { id: "insurers", label: "Insurers", layer: 2, role: "Pricing, reinsurance, reserving and capital." },
  { id: "banks", label: "Banks", layer: 3, role: "Mortgage, credit, portfolio and disclosure decisions." },
  { id: "apra", label: "APRA / ARPC", layer: 4, role: "Prudential expectations and cyclone pool trigger." }
];

export const ecosystemEdges = [
  ["bom", "rms"],
  ["bom", "verisk"],
  ["bom", "xdi"],
  ["ga", "rms"],
  ["ga", "xdi"],
  ["rms", "insurers"],
  ["verisk", "insurers"],
  ["xdi", "banks"],
  ["insurers", "apra"],
  ["banks", "apra"]
] as const;
